/**
 * "Delete this playlist?" confirmation.
 *
 * Says outright that the songs stay. Deleting something that visibly contains twelve
 * tracks is the one place where a user could reasonably fear they are deleting the
 * tracks, and the whole point of a playlist holding ids is that they are not.
 */
import { Trash2 } from 'lucide-react';
import ConfirmDialog from './ConfirmDialog';
import { c } from '../../styles/theme';
import type { Playlist } from '../../types/domain';

export interface DeletePlaylistModalProps {
  /** The playlist pending deletion, or null when closed. */
  playlist: Playlist | null;
  onClose: () => void;
  onConfirm: () => void;
}

export default function DeletePlaylistModal({
  playlist,
  onClose,
  onConfirm,
}: DeletePlaylistModalProps) {
  return (
    <ConfirmDialog
      open={Boolean(playlist)}
      onClose={onClose}
      title="Delete this playlist?"
      icon={<Trash2 size={19} color={c.danger} />}
      destructive
      confirmLabel="Delete playlist"
      confirmIcon={<Trash2 size={13} />}
      onConfirm={onConfirm}
    >
      <p style={{ fontSize: 12, color: c.text2, margin: '0 0 18px', lineHeight: 1.5 }}>
        "{playlist?.name}" will be removed. Your songs stay in your library.
      </p>
    </ConfirmDialog>
  );
}
